module.exports = "/static-assets/_next/static/images/diamond-gemstone-1-1d8e37540216a2d1240c3e395e499215.png";